export const SET_LOADING = "SET_LOADING";
export const SET_PERSONAL_INFO = "SET_PERSONAL_INFO";
export const SET_NOK_INFO = "SET_NOK_INFO";
export const SET_GUARANTOR_INFO = "SET_GUARANTOR_INFO";
export const SET_DOCUMENTS = "SET_DOCUMENTS";
export const CLEAR_AGENT_DETAILS = "CLEAR_AGENT_DETAILS";
export const SET_UPLOADED_DOCS = "SET_UPLOADED_DOCS";
export const INVALIDATE_UPLOADED_DOC = "INVALIDATE_UPLOADED_DOC";